/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';
import type { ThirdPartyViewModel } from './ThirdPartyViewModel';
import {
    ThirdPartyViewModelFromJSON,
    ThirdPartyViewModelFromJSONTyped,
    ThirdPartyViewModelToJSON,
} from './ThirdPartyViewModel';

/**
 * 
 * @export
 * @interface ResultOfThirdPartyViewModel
 */
export interface ResultOfThirdPartyViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfThirdPartyViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfThirdPartyViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfThirdPartyViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfThirdPartyViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfThirdPartyViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfThirdPartyViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfThirdPartyViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {ThirdPartyViewModel}
     * @memberof ResultOfThirdPartyViewModel
     */
    data?: ThirdPartyViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfThirdPartyViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfThirdPartyViewModel interface.
 */
export function instanceOfResultOfThirdPartyViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfThirdPartyViewModelFromJSON(json: any): ResultOfThirdPartyViewModel {
    return ResultOfThirdPartyViewModelFromJSONTyped(json, false);
}

export function ResultOfThirdPartyViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfThirdPartyViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ThirdPartyViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfThirdPartyViewModelToJSON(value?: ResultOfThirdPartyViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': ThirdPartyViewModelToJSON(value.data),
        'Count': value.count,
    };
}

